import { ClerkProvider, Show, RedirectToSignIn } from '@clerk/react';
import ReactDOM from 'react-dom/client';
import {
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import AppShell from './components/navigation/AppShell';
import AiAnalyticsPage from './pages/AiAnalyticsPage';
import AiExecutionsPage from './pages/AiExecutionsPage';
import DashboardPage from './pages/DashboardPage';
import NavigationHistoryPage from './pages/NavigationHistoryPage';
import PageNavigationPage from './pages/PageNavigationPage';
import ReferralsListPage from './pages/ReferralsListPage';
import SendEmailPage from './pages/SendEmailPage';
import UsersListPage from './pages/UsersListPage';
import ViewUserPage from './pages/ViewUserPage';
import UserChatsPage from './pages/UserChatsPage';
import UserProjectsPage from './pages/UserProjectsPage';
import UserDocumentsPage from './pages/UserDocumentsPage';
import UserPaymentsPage from './pages/UserPaymentsPage';
import UserCostAuditPage from './pages/UserCostAuditPage';
import UserLogsPage from './pages/UserLogsPage';
import './index.css';

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!clerkPubKey) {
  throw new Error('VITE_CLERK_PUBLISHABLE_KEY is not defined');
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppShell />}>
      <Route index element={<DashboardPage />} />
      <Route path="users" element={<UsersListPage />} />
      <Route path="users/:userId" element={<ViewUserPage />} />
      <Route path="users/:userId/navigation" element={<PageNavigationPage />} />
      <Route
        path="users/:userId/ai-executions"
        element={<AiExecutionsPage />}
      />
      <Route path="users/:userId/send-email" element={<SendEmailPage />} />
      <Route path="users/:userId/chats" element={<UserChatsPage />} />
      <Route path="users/:userId/projects" element={<UserProjectsPage />} />
      <Route path="users/:userId/documents" element={<UserDocumentsPage />} />
      <Route path="users/:userId/payments" element={<UserPaymentsPage />} />
      <Route path="users/:userId/cost-audit" element={<UserCostAuditPage />} />
      <Route path="users/:userId/logs" element={<UserLogsPage />} />
      <Route path="referrals" element={<ReferralsListPage />} />
      <Route path="ai-analytics" element={<AiAnalyticsPage />} />
      <Route path="navigation" element={<NavigationHistoryPage />} />
    </Route>,
  ),
);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <ClerkProvider publishableKey={clerkPubKey} signInFallbackRedirectUrl="/">
    <Show when="signed-in">
      <RouterProvider router={router} />
    </Show>
    <Show when="signed-out">
      <RedirectToSignIn />
    </Show>
  </ClerkProvider>,
);
